import { MapPin, Calendar, User, CheckCircle } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      icon: <MapPin className="w-8 h-8" />,
      title: 'Tell us where you are',
      description: 'Enter your home or office address'
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: 'Choose your service & time',
      description: 'Select from our range of grooming services'
    },
    {
      icon: <User className="w-8 h-8" />,
      title: 'Meet your barber',
      description: 'Track your barber in real-time as they arrive'
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: 'Enjoy your fresh cut',
      description: 'Pay securely with cash or card'
    }
  ];

  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="section bg-[var(--bg-secondary)] dark:bg-[#1A1A1A]">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[var(--text-primary)] mb-4" data-testid="how-it-works-heading">
            How it works
          </h2>
          <p className="text-base text-[var(--text-secondary)] leading-relaxed">
            Getting a fresh cut has never been easier. Book in just 4 simple steps.
          </p>
        </div>

        {/* Timeline */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-testid="how-it-works-steps">
          {steps.map((step, index) => (
            <div key={index} data-testid={`step-${index + 1}`} className="relative">
              {/* Connector Line - Desktop Only */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[calc(50%+24px)] w-full h-0.5 bg-gradient-to-r from-[#00C167] to-transparent"></div>
              )}

              {/* Step Card */}
              <div className="text-center relative z-10">
                {/* Step Number */}
                <div className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#00C167] text-white text-xs font-bold mb-4">
                  {index + 1}
                </div>

                {/* Icon */}
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#00C167]/10 text-[#00C167] mb-4">
                  {step.icon}
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-[var(--text-secondary)]">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;